import React, { useEffect, useRef, useState } from "react";
import { Line, Bar, Pie } from "react-chartjs-2";
import { useForm } from "react-hook-form";
import { Chart as ChartJS, registerables } from "chart.js";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import dashboardService, { getTotalApplicationsByType } from "../../services/dashboard-service";
import sectionService from "../../services/section-service";
import userService from "../../services/user-service";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { es } from "date-fns/locale/es";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button, Divider, Spin } from "antd";
import LineChart from "../DashBoard/LineChart";
import { CloudDownloadOutlined, DownloadOutlined } from "@ant-design/icons";
import BarchartDay from "../DashBoard/BarchartDay";
import moment from "moment/moment";
import config from "../../config/config";
import Select from "react-select";
import BarLineLineChart from "../DashBoard/BarLineLineChart";
import html2canvas from "html2canvas";



// Registrar componentes para Chart.js
ChartJS.register(...registerables);

const DashboardPerformance = () => {


  const dashboardRef = useRef();
  const chartSixRef = useRef(null);


  const [showLineValues, setShowLineValues] = useState(true)
  const [expandChats, setExpandCharts] = useState(false)
  const [listLineData, setListLineData] = useState([]);
  const [hectaresData, setHectaresData] = useState([]);
  const [listLineAveragePalm, setListLineAveragePalm] = useState([]);

  const [loading, setLoading] = useState(false);

  ///Aplicaciones por dia
  const [lotId, setLotId] = useState("0");
  const [farmId, setFarmId] = useState("0");

  const [totalFirst, setTotalFirst] = useState(0);
  const [totalSecond, setTotalSecond] = useState(0);
  const [totalThird, setTotalThird] = useState(0);
  const [total, setTotal] = useState(0);

  const [valuesUserX, setValuesUserX] = useState([])
  const [valuesUserY, setValuesUserY] = useState([])
  const [valuesUserYQ, setValuesUserYQ] = useState([])

  const [valuesLotX, setValuesLotX] = useState([])
  const [valuesLotY, setValuesLotY] = useState([])

  const [valuesHourX, setValuesHourX] = useState([])
  const [valuesHourY, setValuesHourY] = useState([])


  registerLocale("es", es);

  const start_date = moment().add(-7, 'd').endOf("day").toDate();
  const end_date = moment().startOf("day").toDate();

  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);

  const [listSection, setListSection] = useState(escoja);
  const [sectionId, setSectionId] = useState("0");




  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  const [options, setOptions] = useState([])
  const [selectedLotes, setSelectedLotes] = useState([]);
  const handleSelectChange = (selectedOptions) => {
    setSelectedLotes(selectedOptions || []);
  };

  // Estilos personalizados  
  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#CBEDFE",
      fontFamily: "inherit",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
    menu: (styles) => ({
      ...styles,
      fontFamily: "inherit",
    }),
  };
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////
  ////MULTISELECT/////////////




  const formatDate = (dateString) => {
    return moment(dateString).locale('es').format('DD MMM');
  };


  const changeStateShowValues = (e) => {
    setShowLineValues(!e.target.checked)
  }

  const changeExpand = (e) => {
    setExpandCharts(e.target.checked)
  }



  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
      //setValue("farm",0)
    }
  };

  const getListSection = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setFarmId(code);
    if (code == "0") {
      setListSection(escoja);
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
    }
  };

  const getLisLots = async (e) => {
    setSelectedLotes([])
    setOptions([])
    const code = e.target.value;
    setSectionId(code);
    if (code == "0") {
      setListLots(escoja);
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      const newOptions = sortedItems.map((lote) => ({
        value: lote._id,
        label: lote.name,
      }));
      setOptions(newOptions)
    }
  };









  ////APLICACIONES POR TIPO
  const getTotalApplicationsByType = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setTotalFirst(0);
    setTotalSecond(0);
    setTotalThird(0);
    setLoading(true);
    const userId = getValues("userId")
    const result = await dashboardService.getTotalApplicationsByType(start, end, farmId, lotId, sectionId, selectedLotes, userId);
    if (result) {
      if (result.length > 0) {
        const sum = result[0].totalFirst + result[0].totalSecond + result[0].totalThird
        setTotalFirst(result[0].totalFirst);
        setTotalSecond(result[0].totalSecond);
        setTotalThird(result[0].totalThird);
        setTotal(sum);
        setLoading(false);
      }
    }

  };





  ///APLICACIONES POR HORA  
  const getTotalApplicationsByHour = async () => {

    let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setValuesHourX([])
    setValuesHourY([])
    const userId = getValues("userId")
    const result = await dashboardService.getTotalApplicationsByHour(start, end, farmId, lotId, sectionId, selectedLotes, userId);
    let listX = [];
    let listY = [];
    if (result) {
      result.map((item) => {
        const hour = item.hour;
        const total = item.quantity;
        listX.push(hour)
        listY.push(total)
      });
    }
    setValuesHourX(listX)
    setValuesHourY(listY)
  };




  const getListFilterUsers = async () => {

    const farmId = getValues("farm")
    const lotId = getValues("lot")
    const userId = "0"
    setValue("userId", "0")
    try {
      let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
      let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
      const response = await userService.listInAccumulation(start, end, farmId, sectionId, lotId)
      const listado = response.data
      if (listado) {
        listado.push({ _id: 0, name: "-ESCOJA-" });
        const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
        setListUsers(sortedItems);
      }
    } catch (error) { }
  }
  useEffect(() => {
    getListFilterUsers();
  }, [startDate, endDate, farmId, sectionId]);


  const loadDashBoard = () => {

    getTotalApplicationsByType()
    getTotalApplicationsByHour()

  };



  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();






  const cardStyle = {
    padding: "20px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };



  const saveAsImage = (chartRef, title) => {
    if (chartRef.current) {
      const echartsInstance = chartRef.current.getEchartsInstance();
      const imgData = echartsInstance.getDataURL({
        type: "jpeg", // Formato de la imagen ('png', 'jpeg')
        pixelRatio: 2, // Relación de píxeles (mayor = imagen de mayor calidad)
        backgroundColor: "#fff", // Fondo de la imagen
      });

      // Crear un enlace para descargar la imagen
      const link = document.createElement("a");
      link.href = imgData;
      link.download = title; // Nombre del archivo
      link.click();
    }
  };




  const downloadScreenshot = async () => {
    if (!dashboardRef.current) return;

    // Esperar un momento para que el gráfico renderice completamente
    await new Promise((r) => setTimeout(r, 500));

    html2canvas(dashboardRef.current, {
      scale: 2, // aumenta la resolución
      useCORS: true, // necesario si hay imágenes externas
      backgroundColor: "#ffffff",
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = "dashboard-aplicaciones.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };



  useEffect(() => {
    getLisFarm();
    getListFilterUsers()
    loadDashBoard()
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        padding: "20px",
      }}
    >

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Rendimiento por horas</Divider>
      </div>


      <div className="row">
        <div className="col-12">
          <form className="form-react">

            <div className="row mb-5">

              <div className=" col-3 ">
                <label className="text-secondary fw-bold">Finca</label>
                <select
                  className="form-control text-secondary"
                  {...register("farm")}
                  onChange={(e) => getListSection(e)}
                >
                  {listFarms.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className=" col-3 ">
                <label className="text-secondary fw-bold">Sección</label>
                <select
                  className="form-control text-secondary"
                  {...register("section")}
                  onChange={(e) => getLisLots(e)}
                >
                  {listSection.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>







              <div className=" col-6 col-sm-2">
                <label className="text-secondary fw-bold">Desde</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control text-secondary"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>

              <div className=" col-6 col-sm-2">
                <label className="text-secondary fw-bold">Hasta</label>
                <br />
                <DatePicker
                  locale="es"
                  dateFormat="yyyy-MM-dd"
                  className="form-control 
                text-secondary"
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </div>


              <div className=" col-12 col-sm-2">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <button
                  className="btn btn-primary w-100"
                  type="button"
                  onClick={() => loadDashBoard()}
                >
                  <i className="bi bi-search fa-lg m-2" /> Cargar gráfico
                </button>
              </div>




              <div className=" col-6 d-none">
                <label className="text-secondary fw-bold">Lotes</label>
                <Select
                  isMulti
                  options={options}
                  value={selectedLotes}
                  styles={customStyles}
                  onChange={handleSelectChange}
                  placeholder="Selecciona lotes..."
                />
              </div>




              <div className=" col-12 col-sm-3">
                <label className="text-secondary fw-bold">Usuario</label>
                <select
                  className="form-control text-secondary"
                  {...register("userId")}
                >
                  {listUsers.map((option) => (
                    <option key={option._id} value={option._id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>




              <div className="mt-2 col-2 d-none"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeExpand(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Expandir grafica</label>
                </div>
              </div>

              <div className="mt-2 col-2 d-none"><label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" role="switch" onChange={(e) => changeStateShowValues(e)} />
                  <label className="form-check-label" for="flexSwitchCheckDefault">Ocultar valores</label>
                </div>
              </div>


            </div>



          </form>
        </div>




        <div ref={dashboardRef} style={{ paddingTop: "20px", backgroundColor: "#fff" }}>

          <div className="row mb-3">
            <div className="col">
              <div className="shadow p-3 rounded text-center border">
                <span style={{ fontSize: "20px", color: "#00D9A3", fontWeight: "bold" }}>Primera:</span>
                <span style={{ fontSize: "20px", fontWeight: "bold" }} className="ms-2 text-secondary">{totalFirst}</span>
              </div>
            </div>
            <div className="col">
              <div className="shadow p-3 rounded text-center border">
                <span style={{ fontSize: "20px", color: "#FFBF00", fontWeight: "bold" }}>Segunda:</span>
                <span style={{ fontSize: "20px", fontWeight: "bold" }} className="ms-2 text-secondary">{totalSecond}</span>
              </div>
            </div>
            <div className="col">
              <div className="shadow p-3 rounded text-center border">
                <span style={{ fontSize: "20px", color: "#FF4D4D", fontWeight: "bold" }}>Tercera:</span>
                <span style={{ fontSize: "20px", fontWeight: "bold" }} className="ms-2 text-secondary">{totalThird}</span>
              </div>
            </div>
            <div className="col">
              <div className="shadow p-3 rounded text-center border">
                <span style={{ fontSize: "20px", color: "#2693FF", fontWeight: "bold" }}>Total:</span>
                <span style={{ fontSize: "20px", fontWeight: "bold" }} className="ms-2 text-secondary">{total}</span>
              </div>
            </div>
          </div>

          <div className="shadow p-4 rounded bg-white">
            <BarLineLineChart
              chartRef={chartSixRef}
              title="Aplicaciones por hora"
              subTitle="Cantidad de aplicaciones por hora"
              nameBar="Aplicaciones"
              categories={valuesHourX}
              applications={valuesHourY}
            />
          </div>
        </div>

        <div className="col-12 col-sm-4 mt-4">


          <Button
            className="form-control"
            onClick={downloadScreenshot}
            icon={<DownloadOutlined />}
          >
            Descargar vista completa
          </Button>
        </div>




      </div>
    </div>
  );
};

export default DashboardPerformance;
